import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Divider,
  Card,
  CardContent,
  Avatar,
  Grid
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';

export const ChroniclePeople = () => {
  const navigate = useNavigate();

  const testimonials = [
    {
      name: "Klaus M.",
      role: "Busfahrer seit 1998",
      quote: "Ich habe die Entwicklung von den ersten Tagen nach der Bahnreform miterlebt. Es war beeindruckend zu sehen, wie sich unser Unternehmen entwickelt hat.",
      color: "#e3f2fd"
    },
    {
      name: "Andrea S.",
      role: "Disponentin seit 2005",
      quote: "Die Digitalisierung hat unsere Arbeit revolutioniert. Heute können wir viel präziser planen und bei Störungen schneller reagieren.",
      color: "#f3e5f5"
    },
    {
      name: "Michael T.",
      role: "Werkstattleiter seit 2010",
      quote: "Von mechanischen Systemen zu computergesteuerten Bussen - die technische Entwicklung war enorm. Unsere Mechaniker sind heute IT-Experten.",
      color: "#e8f5e8"
    }
  ];

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chronicles')}
        sx={{ mb: 3 }}
      >
        Zurück zur Chronik
      </Button>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#E30613' }}>
          Menschen bei DB Regio Bus
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Seit 1994: Die Gesichter hinter dem Service
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Hinter jedem erfolgreichen Verkehrsunternehmen stehen Menschen, die täglich dafür sorgen, 
          dass Mobilität funktioniert. Bei DB Regio Bus Mitte sind es die Busfahrer, Disponenten, 
          Mechaniker und Verwaltungsmitarbeiter, die das Unternehmen ausmachen.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#f5f5f5' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="primary">
              Unser Team heute
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>
                    ~270
                  </Typography>
                  <Typography variant="body2">Mitarbeiter gesamt</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="secondary" sx={{ fontWeight: 'bold' }}>
                    240
                  </Typography>
                  <Typography variant="body2">Busfahrer</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="success.main" sx={{ fontWeight: 'bold' }}>
                    ~20
                  </Typography>
                  <Typography variant="body2">Werkstatt & Technik</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="warning.main" sx={{ fontWeight: 'bold' }}>
                    ~10
                  </Typography>
                  <Typography variant="body2">Verwaltung</Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Typography variant="h6" gutterBottom sx={{ mt: 4, color: '#E30613' }}>
          Stimmen aus dem Team
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} key={index}>
              <Card sx={{ backgroundColor: testimonial.color }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                    <Avatar sx={{ bgcolor: '#E30613', mt: 1 }}>
                      <PersonIcon />
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" gutterBottom>
                        {testimonial.name}
                      </Typography>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        {testimonial.role}
                      </Typography>
                      <Typography variant="body1" sx={{ fontStyle: 'italic', mt: 2 }}>
                        "{testimonial.quote}"
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7, mt: 4 }}>
          Die Ausbildung junger Menschen hat bei DB Regio Bus Mitte eine lange Tradition. 
          Viele der heutigen erfahrenen Mitarbeiter begannen ihre Laufbahn als Auszubildende 
          und sind dem Unternehmen über Jahrzehnte treu geblieben.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#fff3e0' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="warning.main">
              Unsere Werte
            </Typography>
            <Typography variant="body1">
              • Zuverlässigkeit und Pünktlichkeit<br />
              • Kundenorientierung und Freundlichkeit<br />
              • Sicherheit steht an erster Stelle<br />
              • Umweltbewusstsein und Nachhaltigkeit<br />
              • Teamgeist und gegenseitige Unterstützung
            </Typography>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die Corona-Pandemie 2020-2022 stellte alle Mitarbeiter vor besondere Herausforderungen. 
          Durch Zusammenhalt und Flexibilität konnte DB Regio Bus Mitte auch in schwierigen 
          Zeiten einen zuverlässigen Service aufrechterhalten und zeigte, was ein starkes 
          Team erreichen kann.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ backgroundColor: '#e3f2fd' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quellen:
            </Typography>
            <Typography variant="body2" component="div">
              • Interne Mitarbeiterbefragungen 2020, 2022, 2024<br />
              • DB Regio Personalstatistiken (anonymisiert)<br />
              • Betriebsrat-Protokolle und Jahresberichte<br />
              • Interviews mit langjährigen Mitarbeitern (2024)<br />
              • Hinweis: Alle Zitate sind anonymisiert und repräsentativ
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default ChroniclePeople;